const DWPRReducer = (state = {}, action) => {
    switch (action.type) {
        case "DWPRLIST_DOCS":
            return Object.assign({}, state, {
                DWPR_ListView: action.data
            });
        case "LOOKUP_DWPRDESC":
            return Object.assign({}, state, {
                DWPRDESC_LOOKUP: action.data
            });
        case "DWPREDIT_DOCS":
            return Object.assign({}, state, {
                geteditdwpr: action.data
            });
        case "SHARE_DWPRFILES":
            return Object.assign({}, state, {
                shareddwprfile: action.data
            });
        case "SHARE_DWPRDATAS":
            return Object.assign({}, state, {
                shareddwprdata: action.data
            });
        case "ERROR_DWPRFILES":
            return Object.assign({}, state, {
                errordwprpass: action.data
            });
        case "PASS_DWPROTHERS":
            return Object.assign({}, state, {
                othersdwprpass: action.data
            });
        default:
            return state;
    }
};

export default DWPRReducer;